import * as React from "react";
import { Block, TExtendedBlockProps } from "kanopi-components/Block";
import { FixedFooter } from "kanopi-components/Sticky/FixedFooter";

type TProps = {
  blockOverrides?: TExtendedBlockProps;
};

const PolicyFixedFooter: React.FC<TProps> = (props) => {
  let elements = React.Children.toArray(props.children);
  const { blockOverrides } = props;

  if (elements.length > 0) {
    const lastElement = elements[elements.length - 1];

    elements = elements.slice(0, -1).map((child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          overrides: {
            BaseButton: {
              style: {
                marginBottom: "18px",
              },
            },
          },
        });
      }

      return child;
    });

    elements.push(lastElement);
  }
  const defaultPadding = { padding: ["scale800", "scale800", "scale1600"] };

  return (
    <FixedFooter>
      <Block
        {...(Object.keys(blockOverrides || {}).length
          ? blockOverrides
          : defaultPadding)}
      >
        {elements}
      </Block>
    </FixedFooter>
  );
};

export { PolicyFixedFooter };
